<template>
  <IndexHome />
</template>

<script>
import 'ant-design-vue/dist/reset.css';

import IndexHome from './components/IndexHome.vue'

export default {
  name: 'App',
  components: {
    IndexHome
  }
}
</script>

<style>
#app {
  font-size: 14px;
  max-width: 1200px;
  width: 100%;
  background-color: white;
}
</style>
